import axios from "axios";

const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("dyntra_connect_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  const cid = localStorage.getItem("dyntra_connect_clinic_id");
  if (cid) cfg.headers["X-Clinic-Id"] = cid;
  return cfg;
});

export const fmtApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
};

export const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

export default api;
